var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2D9CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9441 14.46V15.96C16.9446 16.0993 16.9161 16.2371 16.8603 16.3647C16.8045 16.4923 16.7227 16.6068 16.6201 16.701C16.5175 16.7951 16.3963 16.8668 16.2644 16.9114C16.1325 16.956 15.9927 16.9726 15.8541 16.96C14.3155 16.7929 12.8376 16.2671 11.5391 15.425C10.331 14.6574 9.30673 13.6331 8.53906 12.425C7.69405 11.1207 7.16818 9.63555 7.00406 8.09005C6.99156 7.95178 7.008 7.81243 7.05231 7.68086C7.09662 7.54929 7.16784 7.42839 7.26144 7.32586C7.35504 7.22332 7.46896 7.1414 7.59595 7.08531C7.72295 7.02922 7.86023 7.00018 7.99906 7.00005H9.49906C9.74171 6.99766 9.97695 7.08359 10.1609 7.24181C10.3449 7.40004 10.4651 7.61977 10.4991 7.86005C10.5624 8.34008 10.6798 8.81141 10.8491 9.26505C10.9163 9.44401 10.9309 9.63851 10.891 9.82549C10.8511 10.0125 10.7585 10.1841 10.6241 10.32L9.98906 10.955C10.7008 12.2068 11.7373 13.2433 12.9891 13.955L13.6241 13.32C13.76 13.1856 13.9316 13.093 14.1186 13.0531C14.3056 13.0132 14.5001 13.0278 14.6791 13.095C15.1327 13.2643 15.604 13.3817 16.0841 13.445C16.3269 13.4793 16.5488 13.6017 16.7073 13.7888C16.8659 13.9759 16.9501 14.2148 16.9441 14.46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.00efac0b349cda7855ba60a425f4655e.svg";
export { ForwardRef as ReactComponent };